export default "__VITE_ASSET__CylfbnHd__"